import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = {
    tokenHeaderClientId: "663af5d9b9221d6b480883ef",
    clientId: "NtMfXN7qRT2vCfWJr50Fbg",
    clientSecret: "BTmPu5hb4LiSBt17SDLOouJeSbau9AdYVWSzmnvZ94U",
    applicationId: '65e56e48fa7860a3550e62fb',
    platform: "ANDROID"
};

import mutations from "@/store/mutations";
import actions from "@/store/actions";
import getters from "@/store/getters";

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
});
